<template>
  <div
    class="w-full h-full flex flex-col relative animate-fade-in"
    :class="theme.text"
  >
    <div class="shrink-0 h-12 flex items-center justify-between px-4 z-10">
      <button @click="$emit('back')">
        <icon-base
          name="ChevronLeft"
          class="w-6 h-6 opacity-60 hover:opacity-100"
        ></icon-base>
      </button>
      <span class="font-bold">{{ t.sync_title }}</span>
      <div class="w-6"></div>
    </div>
    <div class="flex-1 px-6 py-6">
      <div
        class="p-6 rounded-3xl mb-6 text-center"
        :class="theme.isDark ? 'bg-white/5' : 'bg-black/5'"
      >
        <div
          class="w-16 h-16 rounded-full bg-blue-500/10 flex items-center justify-center mx-auto mb-4"
        >
          <icon-base name="Cloud" class="w-8 h-8 text-blue-500"></icon-base>
        </div>
        <div class="text-2xl font-bold mb-1">{{ t.sync_cloud_data }}</div>
        <div class="text-sm opacity-50">
          {{ t.sync_last_time }}: {{ lastSyncDisplay }}
        </div>
        <div class="mt-4 flex justify-center gap-4 text-xs opacity-60">
          <div>{{ recordCount }} {{ t.sync_records }}</div>
        </div>
      </div>
      <div class="space-y-4">
        <div
          class="flex items-center justify-between p-4 rounded-2xl"
          :class="
            theme.isDark ? 'bg-white/5' : 'bg-white border border-black/5'
          "
        >
          <div>
            <div class="font-bold mb-0.5">{{ t.sync_auto }}</div>
            <div class="text-xs opacity-50">{{ t.sync_backup_desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-6">
      <button
        @click="handleSync"
        :disabled="syncing"
        class="w-full py-4 rounded-2xl font-bold text-lg shadow-lg flex items-center justify-center gap-2 active:scale-95 transition-all disabled:opacity-60"
        :class="theme.isDark ? 'bg-white text-black' : 'bg-black text-white'"
      >
        <icon-base
          v-if="syncing"
          name="Refresh"
          class="w-5 h-5 animate-spin"
        ></icon-base
        >{{ syncing ? t.sync_syncing : t.sync_now }}
      </button>
    </div>

    <div
      v-if="toast"
      class="absolute bottom-24 left-1/2 -translate-x-1/2 text-xs px-3 py-1.5 rounded-full animate-fade-in"
      :class="theme.isDark ? 'bg-white/15 text-white' : 'bg-black/70 text-white'"
    >
      {{ toast }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    theme: { type: Object, required: true },
    t: { type: Object, required: true },
    isPro: { type: Boolean, default: false },
    recordCount: { type: Number, default: 0 },
    lastSyncAt: { type: Number, default: null },
    onSync: { type: Function, default: null },
  },
  data() {
    return {
      syncing: false,
      lastSyncTs: this.lastSyncAt,
      toast: "",
    };
  },
  computed: {
    lastSyncDisplay() {
      if (!this.lastSyncTs) return this.t.sync_never;
      return new Date(this.lastSyncTs).toLocaleString();
    },
  },
  watch: {
    lastSyncAt(val) {
      this.lastSyncTs = val;
    },
  },
  beforeDestroy() {
    clearTimeout(this._toastTimer);
  },
  methods: {
    async handleSync() {
      if (this.syncing || !this.onSync) return;
      this.syncing = true;
      try {
        const res = await this.onSync();
        if (res && res.time) this.lastSyncTs = res.time;
        this.flashToast(this.t.sync_toast);
      } catch (e) {
        this.flashToast(this.t.sync_fail_toast);
      } finally {
        this.syncing = false;
      }
    },
    flashToast(msg) {
      this.toast = msg;
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => (this.toast = ""), 2200);
    },
  },
};
</script>
